/**
 * @generated SignedSource<<17db8e09486723f723ce5944d1cb334a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LaunchMarketingEmailDialog_marketingEmail$data = {
  readonly emailTemplate: {
    readonly name: string;
  } | null | undefined;
  readonly id: string;
  readonly mailingList: {
    readonly name: string;
    readonly subscribedCount: number;
  } | null | undefined;
  readonly name: string;
  readonly " $fragmentType": "LaunchMarketingEmailDialog_marketingEmail";
};
export type LaunchMarketingEmailDialog_marketingEmail$key = {
  readonly " $data"?: LaunchMarketingEmailDialog_marketingEmail$data;
  readonly " $fragmentSpreads": FragmentRefs<"LaunchMarketingEmailDialog_marketingEmail">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LaunchMarketingEmailDialog_marketingEmail",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MailingList",
      "kind": "LinkedField",
      "name": "mailingList",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subscribedCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EmailTemplate",
      "kind": "LinkedField",
      "name": "emailTemplate",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "MarketingEmail",
  "abstractKey": null
};
})();

(node as any).hash = "8fc18f83927cb6e9b86b37bf981d77ca";

export default node;
